module.exports = __webpack_public_path__ + "static/img/background-login.35a64d61.jpg";